import React from 'react';
import Game from './Game';
import Leaderboard from './Leaderboard';
import './App.css';

function App() {
  return (
    <main className="app-shell">
      <section className="hero-section">
        <div className="hero-copy">
          <h1>Which LLMs are actually funniest?</h1>
          <p className="hero-description">
            The rankings are based on how closely each model's humor matches
            what real human judges actually find funny — the higher the score,
            the more consistent the LLM is with human taste in comedy.
          </p>
        </div>
      </section>

      <section className="leaderboard-section">
        <Leaderboard />
      </section>

      <section className="sample-game-section" aria-labelledby="sample-game-title">
        <div className="section-heading">
          <h2 id="sample-game-title">Sample human-vote round</h2>
        </div>
        <Game />
      </section>
    </main>
  );
}

export default App;
